import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const DateFormatter = ({
  date,
  period,
  format = 'YYYY-MM-DD',
  monthFormatter = 'YYYY-MMM',
  className = '',
  showTime = false,
}) => {
  if (!date) return <div className={className}>-</div>;

  let formattedDate;

  const base = dayjs.utc(date);

  if (period === 'year') {
    formattedDate = base.format('YYYY');
  } else if (period === 'month') {
    formattedDate = base.format(monthFormatter);
  } else {
    const finalFormat = showTime ? `${format} HH:mm:ss` : format;
    formattedDate = base.format(finalFormat);
  }

  return <div className={className}>{formattedDate}</div>;
};

export default DateFormatter;
